var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.resales-not-published'),"name":"resalesNotPublished","url":_vm.$listRoutes.resalesWaitingPublication,"table":_vm.resalesNotPublished,"filters":_vm.resalesNotPublishedFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }